import { IQuery, Topics } from '@zaplify/common';

export class IsAllowedToPurchaseQuery extends IQuery<{ isAllowed: boolean; maxAllowed?: number }> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly numberOfPurchases: number) {
        super();
    }
}
